const SvgIo = (props) => (
  <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeWidth={2.002}
      transform="translate(0 -1)"
    >
      <path d="M10.065 6.7L.857 15.058l9.208-8.356s0 0 0 0zM10.168 6.809a3.087 3.087 0 0 1 4.363-4.364 3.087 3.087 0 0 1-4.363 4.364zM14.278 19.3l9.208-8.357-9.208 8.356s0 0 0 0z" />
      <path d="M14.175 19.191a3.087 3.087 0 0 1-4.364 4.364 3.087 3.087 0 0 1 4.364-4.364z" />
    </g>
  </svg>
)

export default SvgIo
